import { useContext } from "react";
import { Skeleton } from "antd";
import { BookOutlined, SendOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { UiTextsContext } from "../../../contexts/Contexts";

const News = ({ dataList, loading = false }) => {
  const { texts } = useContext(UiTextsContext);
  const navigate = useNavigate();

  const handleRedirect = (newsId) => {
    navigate(`/blogSection/${newsId}`);
  };

  return (
    <div className="news-scroll news-list-home">
      {loading ? (
        <>
          <Skeleton.Image active style={{ width: "100%", height: 140 }} />
          <Skeleton.Image active style={{ width: "100%", height: 140 }} />
          <Skeleton.Image active style={{ width: "100%", height: 140 }} />
        </>
      ) : null}
      {!loading && dataList?.map((news) => (
        <article
          key={news?.idNoticia}
          className="news-card-home"
          onClick={() => handleRedirect(news?.idNoticia)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              handleRedirect(news?.idNoticia);
            }
          }}
        >
          <img
            alt={news?.titulo}
            src={news?.imagenUrl}
            className="news-card-home__img"
          />

          <div className="news-card-home__overlay">
            <span className="news-card-home__tag">
              {texts?.LB0288 || "Nomad Alert"}
            </span>

            <div className="news-card-home__footer">
              <div className="news-card-home__text">
                <h3 className="news-card-home__title">{news?.titulo}</h3>
                <button
                  type="button"
                  className="news-card-home__cta"
                  onClick={(event) => {
                    event.stopPropagation();
                    handleRedirect(news?.idNoticia);
                  }}
                >
                  {texts?.LB0462 || "Read more"}
                </button>
              </div>

              <div className="news-card-home__icons">
                <button
                  type="button"
                  className="news-card-home__icon news-card-home__icon-button"
                  aria-label={texts?.LB0462 || "Read more"}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleRedirect(news?.idNoticia);
                  }}
                >
                  <SendOutlined />
                </button>
                <span className="news-card-home__icon">
                  <BookOutlined />
                </span>
              </div>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};

export default News;
